/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.10.4",
    versionName: "0.7.0-nightly.2026.10.4",
    versionChannel: "nightly",
    buildDate: "2026-10-04T00:59:37.194Z",
    commitHash: "dcc85a1b9d0dc4e1ed7eb50121a655a3eb3f95af",
};
